// Single source of truth for the `optimize.settings.v1` localStorage blob.
// Both ThemeProvider and LocaleProvider write into this blob, so writes must be
// merge-safe (read-modify-write) or one provider would clobber the other's keys.

const STORAGE_KEY = 'optimize.settings.v1';

export function readSettingsBlob(): Record<string, unknown> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

export function patchSettingsBlob(patch: object): void {
  try {
    const next = { ...readSettingsBlob(), ...patch };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* localStorage unavailable (private mode / SSR) — ignore */
  }
}
